import React from "react";

const BasicViewerSwitch = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1.45801 17.5C1.28092 17.5 1.13249 17.4398 1.0127 17.3193C0.892904 17.1988 0.833008 17.0495 0.833008 16.8714C0.833008 16.6932 0.892904 16.5451 1.0127 16.4271C1.13249 16.309 1.28092 16.25 1.45801 16.25H18.5413C18.7184 16.25 18.8669 16.3102 18.9867 16.4307C19.1064 16.5512 19.1663 16.7005 19.1663 16.8786C19.1663 17.0568 19.1064 17.2049 18.9867 17.3229C18.8669 17.441 18.7184 17.5 18.5413 17.5H1.45801ZM2.91634 15C2.58301 15 2.29134 14.875 2.04134 14.625C1.79134 14.375 1.66634 14.0833 1.66634 13.75V3.75C1.66634 3.41667 1.79134 3.125 2.04134 2.875C2.29134 2.625 2.58301 2.5 2.91634 2.5H17.083C17.4163 2.5 17.708 2.625 17.958 2.875C18.208 3.125 18.333 3.41667 18.333 3.75V13.75C18.333 14.0833 18.208 14.375 17.958 14.625C17.708 14.875 17.4163 15 17.083 15H2.91634ZM2.91634 13.75H17.083V3.75H2.91634V13.75Z"
        fill="rgb(66, 66, 66)"
      />
    </svg>
  );
};

export default BasicViewerSwitch;
